import {
  ADD_TURBINE_SECTION_FAILED,
  ADD_TURBINE_SECTION_SUCCESS,
  LIST_ASSET_SECTIONS_SUCCESS,
  RESET_TURBINE_SECTION_ADD,
  TRIGGER_TURBINE_SECTION_API,
  QUEUE_LIST,
  ADD_GET_PROGRESS_SET,
  SET_ASSET_IMAGES,
  SET_BLADE_SECTION_DATA,
  SET_ALERT_DATA_AUDIT,
  SET_ASSET_IMAGES_LOADER,
  SET_BLADE_SECTION_DATA_LOADING,
  SET_DATA_SECTION_LOADING,
  SET_DATA_EXPORT_LOADING,
  SET_DATA_DELETE_LOADING_2,
  SET_BTN_FALSE,
  SET_THRESHOLD_DATA,
  IN_PROGRESS_RAW_UPLOAD,
  IN_UPLOADING_RAW_UPLOAD,
  IN_PROGRESS_RAW_UPLOAD_COUNT,
  SET_TRIGGER_UPLOAD_DATA,
  SET_RAW_UPLOAD_MINIMIZED_STATUS,
  SET_ASSET_IMAGES_LOADER_2,
  SET_ASSET_IMAGES_DATA_2,
  TRIGGER_CHECK_API,
  SET_ASSET_IMAGES_UNMAPPED,
  SET_ASSET_IMAGES_LOADER_UNMAPPED,
  IN_PROGRESS_RAW_UPLOAD_MESSAGE,
  DELETE_BASE_LAYER_LOADING,
} from '../actions/types'
const initialState = {
  loading: true,
  isError: false,
  isErrorType: null,
  errMessage: null,
  assetsSummary: [],
  section_summary: [],
  isOpen: false,
  triggerType: false,
  uploadSections: [],
  isAddAlert: false,
  isAddAlertType: null,
  addAlertMessage: '',
  isAddAlertStatus: null,
  sectionBladeData: [],
  assets_images: [],
  assets_images_loader: false,
  queue: [],
  isAlert: false,
  isAlertError: false,
  alertMessage: null,
  sectionBladeDataLoading: false,
  assetSectionLoading: false,
  dataExportLoading: false,
  dataDeleteLoading: false,
  setBtnFalse: false,
  thresholdData: 0,
  inProgressValue: null,
  isUploading: false,
  countProgress: '1/1',
  triggerUploadApi: false,
  rawUploadMinimizedStatus: {
    isMinimized: false,
    isVisible: false,
    sourcePath: "/data/import",
    sourceLabel: "",
  },
  dataUpload2: [],
  dataUpload2Loading: false,
  triggerSummaryApi: false,
  unmappedData: [],
  unmappedDataLoading: false,
  uploadMessage: '',
  deletingLayer: false,
}

function companyReducer(state = initialState, action) {
  const { type, payload } = action
  switch (type) {
    case DELETE_BASE_LAYER_LOADING:
      return {
        ...state,
        deletingLayer: payload.loading,
      }
    case TRIGGER_CHECK_API:
      return {
        ...state,
        triggerSummaryApi: payload,
      }
    case SET_ASSET_IMAGES_LOADER_2:
      return {
        ...state,
        dataUpload2Loading: payload,
      }
    case SET_ASSET_IMAGES_DATA_2:
      return {
        ...state,
        dataUpload2: payload,
      }
    case SET_TRIGGER_UPLOAD_DATA:
      return {
        ...state,
        triggerUploadApi: payload,
      }
    case SET_RAW_UPLOAD_MINIMIZED_STATUS:
      return {
        ...state,
        rawUploadMinimizedStatus: {
          ...state.rawUploadMinimizedStatus,
          ...payload,
        },
      }
    case IN_UPLOADING_RAW_UPLOAD:
      return {
        ...state,
        isUploading: payload,
        rawUploadMinimizedStatus: payload
          ? state.rawUploadMinimizedStatus
          : {
              ...state.rawUploadMinimizedStatus,
              isMinimized: false,
              isVisible: false,
            },
      }
    case IN_PROGRESS_RAW_UPLOAD:
      return {
        ...state,
        inProgressValue: payload,
      }
    case IN_PROGRESS_RAW_UPLOAD_MESSAGE: {
      return { ...state, uploadMessage: payload }
    }
    case IN_PROGRESS_RAW_UPLOAD_COUNT:
      return {
        ...state,
        countProgress: payload,
      }

    case SET_THRESHOLD_DATA:
      return {
        ...state,
        thresholdData: payload,
      }
    case SET_BTN_FALSE:
      return {
        ...state,
        setBtnFalse: payload,
      }
    case SET_DATA_EXPORT_LOADING:
      return {
        ...state,
        dataExportLoading: payload,
      }
    case SET_DATA_DELETE_LOADING_2:
      return {
        ...state,
        dataDeleteLoading: payload,
      }
    case SET_DATA_SECTION_LOADING:
      return {
        ...state,
        assetSectionLoading: payload,
      }
    case SET_ALERT_DATA_AUDIT:
      return {
        ...state,
        isAlert: payload.isAlert,
        isAlertError: payload.isAlertError,
        alertMessage: payload.alertMessage,
      }
    case TRIGGER_TURBINE_SECTION_API:
      return {
        ...state,
        triggerType: payload,
      }
    case LIST_ASSET_SECTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        assetsSummary: payload.assets_summary,
        section_summary: payload.section_summary,
        sectionBladeData: [],
      }
    case SET_BLADE_SECTION_DATA:
      return {
        ...state,
        sectionBladeData: payload,
        sectionBladeDataLoading: false,
      }
    case SET_BLADE_SECTION_DATA_LOADING:
      return {
        ...state,
        sectionBladeDataLoading: payload,
      }
    case ADD_TURBINE_SECTION_FAILED:
      return {
        ...state,
        loading: false,
        uploadSections: [],
        isAddAlert: true,
        isAddAlertType: payload.type,
        addAlertMessage: payload.message,
      }
    case ADD_TURBINE_SECTION_SUCCESS:
      return {
        ...state,
        uploadSections: payload.data,
      }

    case QUEUE_LIST:
      return {
        ...state,
        queue: payload,
      }
    case RESET_TURBINE_SECTION_ADD:
      return {
        ...state,
        uploadSections: [],
        isAddAlert: false,
        isAddAlertType: null,
        addAlertMessage: '',
        isAddAlertStatus: null,
      }
    case ADD_GET_PROGRESS_SET:
      return {
        ...state,
        isAddAlert: payload.isError,
        isAddAlertType: payload.type,
        addAlertMessage: payload.message,
        isAddAlertStatus: payload.status,
      }
    case SET_ASSET_IMAGES:
      return {
        ...state,
        assets_images: payload,
      }
    case SET_ASSET_IMAGES_LOADER:
      return {
        ...state,
        assets_images_loader: payload,
      }
    case SET_ASSET_IMAGES_UNMAPPED:
      return {
        ...state,
        unmappedData: payload,
      }
    case SET_ASSET_IMAGES_LOADER_UNMAPPED:
      return {
        ...state,
        unmappedDataLoading: payload,
      }
    default:
      return state
  }
}

export default companyReducer
